"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const eventConstants_1 = require("../../constants/eventConstants");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const defaultProps = {
    isHorizontal: false,
};
const RadioInput = ({ choices, setValue, value, isHorizontal }) => (react_1.default.createElement(react_native_1.View, { style: isHorizontal ? [styles_1.default.flexDirectionRow] : [styles_1.default.flexDirectionColumn] }, choices.map((choice) => (react_1.default.createElement(pressable_1.default, { key: choice.value.toString(), onPress: () => setValue(choice.value), style: [styles_1.default.flexDirectionRow, styles_1.default.flexOne], eventName: eventConstants_1.RADIO_CHOICE_PRESS },
    react_1.default.createElement(react_native_paper_1.RadioButton, { value: choice.value.toString(), status: value === choice.value ? 'checked' : 'unchecked', onPress: () => setValue(choice.value), color: colors_1.default.BLUE, uncheckedColor: colors_1.default.FONT_GRAY }),
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexOne, styles_1.default.marginFive] },
        react_1.default.createElement(react_native_1.Text, null, choice.label)))))));
RadioInput.defaultProps = defaultProps;
exports.default = RadioInput;
